export const formatPhoneNumber = (inputValue) => {
  const numericValue = inputValue.replace(/\D/g, '');
  if (!numericValue.startsWith('994')) {
    return inputValue;
  }
  return `+${numericValue.slice(0, 3)}-${numericValue.slice(
    3,
    5,
  )}-${numericValue.slice(5, 8)}-${numericValue.slice(
    8,
    10,
  )}-${numericValue.slice(10)}`;
};
